import { Offcanvas } from 'react-bootstrap';

const ViewHistoryOffcanvas = ({ show, onHide, historyList }) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>View History</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                {historyList.length > 0 ? (
                    <div className="">
                        {historyList.map((history) => (
                            <div key={history.id} className='border p-3 rounded-3 mb-3'>
                                <div className='p-tag fs-12'>
                                    {history.date} at {history.time}
                                </div>
                                <div className='p-tag fw-bold border-bottom pb-2'>{history.user}</div>
                                <div className='p-tag mt-2'>
                                    {history.type === 'time' && (
                                        <div className="p-tag">
                                            <strong>Time Log:</strong> {history.duration}
                                        </div>
                                    )}
                                    <div className="p-tag">
                                        {history.action}
                                        <br />
                                        {history.description}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="text-center text-muted">
                        No history available
                    </div>
                )}
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ViewHistoryOffcanvas;
